import { PERMISSION } from "../constants/PERMISSION";
import systemAlert from "./systemAlert";
import { translation } from "./translator";

export const permissionCheck = (history, code) => {
  systemAlert(`"${translation(PERMISSION, code, "code")}"에 대한 권한이 없습니다.`, {
    buttons: [
      {
        label: '이전 페이지로 이동',
        color: 'text',
        onClick: () => {
          //console.log(history)
          history.goBack();
        }
      },
      {
        label: '홈으로 이동',
        color: 'text',
        onClick: () => {
          history.push('/dashboard');
        }
      }
    ]
  });
};